import { render, staticRenderFns } from "./ModalContent.vue?vue&type=template&id=da2cd698&"
import script from "./ModalContent.vue?vue&type=script&lang=ts&"
export * from "./ModalContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports